<template>
    <b-row class="contenido">
        <b-col cols="12" class="mt-3 p-0" v-if="true">
            <div class="alert alert-success d-block d-md-flex justify-content-between align-items-center">
                <h5 class="mb-0"><i class="icon fas fa-check"></i> ¡Compra finalizada correctamente!</h5>
                <Button @click="volverListadoEventos()" class="mt-2 mt-md-0">Volver al listado de eventos</Button>
            </div>
        </b-col>
        <b-col cols="12" class="mt-3 p-0" v-if="error">
            <div class="alert alert-danger alert-dismissible">
                <h5>{{ error }}</h5>
            </div>
        </b-col>
        <template v-if="pedidos">
            <b-col cols="12" class="p-0 pb-3 mt-1" v-for="(pedido, index) in pedidos" :key="index">
                <b-col cols="12" class="pl-0">
                    <div class="d-flex">
                        <h4>Pedido Nº</h4>
                        <h4 id="n-pedido" class="ml-1">{{ n_pedido }}</h4>
                    </div>
                    <hr class="mt-0 mb-2"/>
                    <h4 class="mb-0">{{ pedido.evento.nombre }}</h4>
                    <h5>{{ pedido.sesion.fecha_format }}</h5>
                </b-col>
                <template v-if="pedido.qr_codes">
                    <Button 
                        type="button" 
                        ref="imprimirEntradas"
                        :href="imprimir_url | formatear_url({ '%EVENTO_ID%' : pedido.evento.id, '%SESION_ID%' : pedido.sesion.id, 'qr_codes' : pedido.qr_codes, 'tid': configuracion.hash_teatro })" 
                        target="_blank"
                        class="ml-2 ml-md-0 mb-2 mb-md-0"
                    >
                        IMPRIMIR ENTRADAS
                    </Button>
                    <Button 
                        type="button" 
                        ref="descargarEntradas"
                        :href="pedido.pdf_url"
                        target="_blank"
                        class="ml-2 mb-2 mb-md-0"
                    >
                        DESCARGAR ENTRADAS PDF
                    </Button>
                    <a
                        v-if="datos_compra.metodo_pago.nombre === 'TARJETA'"
                        :href="api_base + '/eventos/' + pedido.evento.id + '/estado/' + pedido.sesion.id + '/pedido/' + n_pedido + '/imprimir-recibo?tid=' + configuracion.hash_teatro + '&api_key=' + api_key"
                        target="_blank"
                        class="ml-2 btn btn-primary"
                        style="color: #E8E6E3 !important; padding-right: 29.7px;"
                    >
                        Imprimir recibo de compra
                    </a>
                </template>
            </b-col>
        </template>
    </b-row>
</template>

<script>
    export default {
        props: {
            n_pedido: {
                type: Number,
                required: true
            },
            pedidos: {
                type: Array,
                required: true
            },
            datos_compra: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                error: false,
                api_base: process.env.VUE_APP_API_BASE,
            }
        },
        methods: {
            volverListadoEventos() {
                this.$router.push({path: '/admin/eventos'});
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            imprimir_url() {
                return this.config.IMPRIMIR_URL;
            },
            api_key() {
                return localStorage.getItem('token');
            }
        }
    }
</script>
<style scoped>
    .contenido {
        background-color: #EDEDED;
        padding: 20px 40px;
        margin-bottom: 50px;
    }
</style>